import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../layout/Header";
import parse from "html-react-parser";

export default function OrderDetailsView() {
    const location = useLocation();
    const navigate = useNavigate();
    const giftView = location.state;

    return (
        <div className="reseller_home">
            <Header name="Home Page" />

            <div className="reseller_home__body">
                <div className="big_card_row">
                    <div className="big_card_boxL">
                        <img src={giftView.image} alt="Gift card" onerror="https://dummyimage.com/600x400/000/fff" />
                    </div>
                    <div className="big_card_boxR">
                        <h3>{giftView.giftcardName}</h3>
                        <p>{parse(giftView?.vendors[0]?.tnc)}</p>
                        <ul>
                            {giftView?.vendors[0]?.denominations?.map((item) => (
                                <>
                                    <li className={giftView.price == item.fix_value ? "active" : ""}>${item.fix_value}</li>
                                </>
                            ))}
                        </ul>

                        <ul>
                            {giftView?.vendors[0]?.denominations?.map(() => (
                                <li>{giftView.discount ? `${giftView.discount} %` : "0"}</li>
                            ))}
                        </ul>
                        {/* <button>Buy Now</button> */}
                        {/* <button onClick={() => navigate('/reseller-details')}>Buy Now</button> */}
                    </div>
                </div>
            </div>
        </div>
    );
}
